import { createFileRoute, notFound, Outlet } from '@tanstack/react-router';

import { FEATURE_FLAGS } from 'shared/consts';
import { requireFeatureFlag } from 'shared/utils';

export const Route = createFileRoute('/_authenticated/locations/$id/_shell/labs')({
  beforeLoad: ({ context }) =>
    requireFeatureFlag(FEATURE_FLAGS.LABS_ALLOWED, context.authUser.featureAllowance, {
      onDisabled: () => {
        throw notFound();
      }
    }),
  component: () => <Outlet />
});
